import {AfterViewInit, ChangeDetectorRef, Directive, EventEmitter, Input, Output} from '@angular/core';
import {NzFormatEmitEvent, NzTreeComponent, NzTreeNode} from 'ng-zorro-antd/tree';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

@Directive({
  selector: '[gn-tree]',
})
export class GnTreeDirective implements AfterViewInit {

  @Input() url: string;
  @Input() valueField: string;
  @Input() textField: string;
  @Input() rootNode: any;
  @Output() initialed = new EventEmitter();

  constructor(private tree: NzTreeComponent,
              private http: HttpClient,
              private changeDetectorRef: ChangeDetectorRef) {
    tree.nzAsyncData = true;
    tree.nzExpandChange.subscribe((event: Required<NzFormatEmitEvent>) => {
      if (event.eventName === 'expand') {
        this.expandNode(event.node);
      }
    });
    tree.nzClick.subscribe((event: NzFormatEmitEvent) => {
      if (!event.node.isSelected && !this.tree.nzMultiple) {
        event.node.isSelected = true;
      } else {
        this.tree.nzSelectedKeys = this.tree.getSelectedNodeList().map(node => node.key);
      }
    });
  }

  reloadSelectNode(): void {
    const selectedNodes = this.tree.getSelectedNodeList();
    if (selectedNodes.length === 0) {
      this.initRoot();
    } else {
      const selectedNode = selectedNodes[0];
      selectedNode.clearChildren();
      selectedNode.isExpanded = true;
      this.expandNode(selectedNode);
    }
  }

  ngAfterViewInit(): void {
    this.initRoot();
  }

  private initRoot(): void {
    if (!this.rootNode) {
      this.loadNodes(null)
        .subscribe(nodes => {
          this.tree.handleNzData(nodes);
          if (nodes.length > 0) {
            this.tree.handleSelectedKeys([nodes[0].key], this.tree.nzMultiple);
            this.tree.nzSelectedKeys = [nodes[0].key];
          }
          this.tree.renderTree();
          this.initialed.emit();
        });
    } else {
      this.tree.handleNzData([{
        title: this.rootNode[this.textField],
        key: this.rootNode[this.valueField],
        data: this.rootNode,
        expanded: false
      }]);
      this.tree.renderTree();
      this.tree.handleSelectedKeys([this.rootNode[this.valueField]], this.tree.nzMultiple);
      this.tree.nzSelectedKeys = [this.rootNode[this.valueField]];
      this.changeDetectorRef.detectChanges();
      this.initialed.emit();
    }
  }

  private expandNode(node: NzTreeNode): void {
    if (node && node.getChildren().length === 0 && node.isExpanded) {
      this.loadNodes(node)
        .subscribe(nodes => {
          node.addChildren(nodes);
        });
    }
  }

  private loadNodes(node: NzTreeNode): Observable<any[]> {
    return new Observable(observer => {
      this.http.get(this.url + (node && node.key !== null ? node.key : ''))
        .subscribe((resp: any[]) => {
          observer.next(resp.map(value => {
              return {title: value[this.textField], key: value[this.valueField], data: value};
            }
          ));
        });
    });
  }

}
